<template>
    <div v-if="showForm" class="documentation-form-modal">
        <div class="modal-content">
            <h2>{{ editing ? 'Редактировать документацию' : 'Добавить документацию' }}</h2>
            <form @submit.prevent="submitForm">
                <div class="form-group">
                    <label for="title">Заголовок:</label>
                    <input type="text" id="title" v-model="form.title" required>
                </div>


                <div class="form-group">
                    <label>Содержание:</label>
                    <Editor
                        v-model="form.content"
                        api-key="miywy5mxfcb0ev9qdi2n8vpxuy47r6wuh3op4dpfvjc1plfk"
                    :init="editorConfig"
                    />
                </div>

                <div class="form-actions">
                    <button type="button" @click="closeForm" class="btn btn-secondary">Отмена</button>
                    <button type="submit" :disabled="loading" class="btn btn-primary">
                        {{ loading ? 'Сохранение...' : 'Сохранить' }}
                    </button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        showForm: Boolean,
        editing: Boolean,
        currentDoc: Object
    },
    data() {
        return {
            form: {
                title: '',
                content: ''
            },
            loading: false,
            editorConfig: {
                height: 500,
                menubar: true,
                language: 'ru',
                plugins: 'preview importcss searchreplace autolink autosave save directionality code visualblocks visualchars fullscreen image link media codesample table charmap pagebreak nonbreaking anchor insertdatetime advlist lists wordcount help charmap quickbars emoticons accordion',
                toolbar: "undo redo | accordion accordionremove | blocks fontfamily fontsize | " +
                    "bold italic underline strikethrough | align numlist bullist | link image |" +
                    " table media | lineheight outdent indent| forecolor backcolor removeformat |" +
                    " charmap emoticons | code fullscreen preview |pagebreak anchor codesample |" +
                    " ltr rtl",
                content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }'
            },
        };
    },
    watch: {
        currentDoc: {
            immediate: true,
            handler(newVal) {
                if (newVal) {
                    this.form = {
                        title: newVal.title,
                        content: newVal.content
                    };
                }
            }
        }
    },
    methods: {
        closeForm() {
            this.$emit('close-form');
            this.resetForm();
        },
        resetForm() {
            this.form = {
                title: '',
                content: ''
            };
        },
        async submitForm() {
            try {
                this.loading = true;

                if (this.editing) {
                    await axios.put(`/api/documentations/${this.currentDoc.id}`, this.form);
                } else {
                    await axios.post('/api/documentations', this.form);
                }

                this.$emit('document-saved');
                this.closeForm();
            } catch (error) {
                console.error('Error saving documentation:', error);
            } finally {
                this.loading = false;
            }
        }
    }
};
</script>

<style scoped>
.documentation-form-modal {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
}

.modal-content {
    background-color: white;
    padding: 30px;
    border-radius: 8px;
    width: 100%;
    max-width: 1280px;
    max-height: 90vh;
    overflow-y: auto;
}

.form-group {
    margin-bottom: 15px;
}

label {
    display: block;
    margin-bottom: 5px;
    font-weight: bold;
}

input, textarea {
    width: 100%;
    padding: 8px;
    border: 1px solid #ddd;
    border-radius: 4px;
}

textarea {
    min-height: 150px;
}

.form-actions {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
    margin-top: 20px;
}

.btn {
    padding: 8px 16px;
    border-radius: 4px;
    cursor: pointer;
}

.btn-primary {
    background-color: #4CAF50;
    color: white;
    border: none;
}

.btn-secondary {
    background-color: #f0f0f0;
    border: 1px solid #ddd;
}

.btn:disabled {
    opacity: 0.6;
    cursor: not-allowed;
}
</style>
